P<template>
  <div class="pa-5">
    <!--タイトル(開発事例)-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--開発事例-->
    <div class="pa-3 ma-3">
      <div
      class="pt-3"
      v-for="(list, i) in lists"
      :key="i">
      <!--事例タイトル-->
        <v-icon color="blue darken-4">
          {{ listIcon }}
        </v-icon>
        <span id="listTitle">
        {{ list.title }}
        </span>

        <!--内容-->
        <v-list
        two-line
        class="pa-5">
          <v-list-item
          v-for="(content, i) in list.contents"
          :key="i">

            <v-list-item-content>
              <v-list-item-title>
                <v-icon>
                  {{ content.icon }}
                </v-icon>
                {{ content.head }}
              </v-list-item-title>
              <p>
                {{ content.description }}
              </p>
            </v-list-item-content>

          </v-list-item>
        </v-list>
      </div>
    </div>
  </div>
</template>

<style>
#listTitle {
  font-size: 19px;
  border-bottom: solid #778899 2px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '開発事例',
      // タイトル横のアイコン
      icon: 'mdi-file-document-outline',
      // 見出しのアイコン
      listIcon: 'mdi-cogs',
      // 事例のリスト
      lists: [
        {
          title: '衛星画像を利用した大規模農業支援システム'
        },
        {
          title: 'KsCIDocsを利用した会報検索システム'
        },
        {
          title: 'KsCIDocsをを利用した学術論文検索システム'
        },
        {
          title: '透析装置監視システム'
        },
        {
          title: '被災地向け医師派遣システム'
        },
        {
          title: 'android端末を利用した訪問介護支援システム'
        },
        {
          title: '国立大学図書館用資産管理システム'
        },
        {
          title: 'グルコース分析装置と連携した定流量ポンプ制御システム'
        },
        {
          title: 'KsCIDocsを利用した企業内文書検索システム'
        },
        {
          title: '卸業社向け販売管理システム'
        }
      ]
    }
  }
}
</script>
